import defaultTransition from './default';
import featuresWorkTransition from './features-work';
import workFeaturesTransition from './work-features';
import featuresProjectTransition from './features-project';

export default [defaultTransition, featuresWorkTransition, workFeaturesTransition, featuresProjectTransition];
